export default __webpack_public_path__ + "static/12.06-f4c137ebc95387987dff9648a8c0458e.png";